import {
    Component,
    OnInit,
    OnDestroy,
    Input,
    Output,
    EventEmitter,
    OnChanges,
    SimpleChange } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs/';

import { DetailsService } from './details.service';
import { UtilService } from '../../../core/services/util.service';

import { SessionService } from '../../../core/services/session.service';
import { NotificationService } from '../../../core/services/notification.service';

@Component({
  selector: 'itpx-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit, OnDestroy, OnChanges {
    @Input() fields: Array<any>;
    @Input() data: any;
    @Input() buttons: Array<any>;
    @Input() hideEmptyFields: boolean;
    @Input() progress: boolean;
    @Input() refresh: Observable<any>;
    @Input() url: string;
    @Output() buttonClick: EventEmitter<any> = new EventEmitter();

    isInProgress: boolean = false;
    emittedAction: string;
    lastClickedButton: boolean = false;

    private dictionaries = {};
    private amberDictionaries = {};
    private sub: Subscription;

    constructor(
            private service: DetailsService,
            private sessionService: SessionService,
            private notificationService: NotificationService,
            private router: Router,
            private route: ActivatedRoute,
            private utilService: UtilService
    ) { }

    ngOnInit() {
        if (!this.fields) {
            throw new Error('ITPx Details component cannot work without [fields]');
        }
        if (this.fields) {
            this.fields.forEach(element => {

                // get dto for type 'dictionary'
                if(element.type === 'dictionary' || element.type === 'amberDictionary' || element.type == 'objectDictionary' || element.type === 'listDictionary') {
                   this.service.getDictionary(element.dictionaryUrl)
                        .subscribe(
                            (data) => {
                                data = element.type === 'objectDictionary' ? this.formatJsonObject(data) : data;
                                this.dictionaries[element.key] = data;
                            }
                        );
                    }

                // get dto for type 'table'
                if(element.type == 'table' && element.config) {
                    element.config.forEach(el => {
                        if(el.type == 'dictionary') {
                            this.service.getDictionary(el.dictionaryUrl)
                                .subscribe(
                                (data) => {
                                    this.dictionaries[el.name] = data;
                                }
                            );
                        }
                    });
                }
            });
        };
    }
    ngOnDestroy() {
        this.endProgress();
        if(this.sub) {
            this.sub.unsubscribe();
        }

    }
    ngDoCheck() {

    }
    ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
        let self = this;
        if (changes['refresh']) {
            if (this.sub) {
                this.sub.unsubscribe();
            }
            if(changes['refresh'].currentValue && this.url) {
                this.sub = this.refresh.subscribe(_ => self.service.refreshData(this.url)
                    .subscribe(
                        (data) => {
                            this.extractData(data);
                        }));
                }
            }
    }
    private extractData(body: any) {
        this.data = <any>body.data;
    }

    private buildRoute(route: string, value: string) {
        let placeholder = '{{keyRoute}}';
        if(route.indexOf(placeholder) > -1)
            route = route.replace(placeholder, value);
        return route;
    }

    private emitAction(emittedAction) {
        this.emittedAction = emittedAction;
        this.buttonClick.emit(emittedAction);
    }

    private getValue(field: any) {
        if(typeof field === 'function') {
            return field(this.data);
        } else if (field.split('.').length > 1) {
                let result = this.data;
                let props = field.split('.');
                props.forEach(v => {
                    if(result)
                        result = result[v];
                });
                return result;
        }
        return this.data ? this.data[field] : null;
    }

    private getFormattedValue(val, key) {
       let result;
        if(this.dictionaries && this.dictionaries[key] && val) {
            let obj = {};
            this.dictionaries[key].forEach(element => {
                if(element.key == val) {
                    result = element.value;
                }
                return result;
            });
        }
        return result;
    }

    private getFormattedValueArray(valArray, key) {
        if(Array.isArray(valArray)) {
            let result = [];
            valArray.forEach(el =>  {
                result.push(this.getFormattedValue(el, key));
            });
            return result
        } else {
            return false
        }
    };

    private getFormattedValueAmberDTO(val, key) {
        let result;
        if(this.dictionaries && this.dictionaries[key] && val) {
            for (let prop in this.dictionaries[key]) {
                if(this.dictionaries[key].hasOwnProperty(prop)) {
                    this.dictionaries[key].forEach(element => {
                        if(element.id == val) {
                            result = element.name;
                        }
                    });
                }
            }
        }
        return result || val;
    }

    private formatJsonObject(obj: any) {
        let result = [];
        for (let prop in obj) {
            if(obj.hasOwnProperty(prop)) {
                result.push({key: prop, value: obj[prop]});
            }
        }
        return result;
    }

    private formatDict(obj: any) {
        let result = [];
        for (let prop in obj) {
            if(obj.hasOwnProperty(prop)) {
                result.push({key: prop, value: obj[prop]});
            }
        }
        return result;
    }

    private goToEditScreen(tab, route) {
        this.router.navigate(
            [route, this.data['id'], 'edit'],
            tab ? { queryParams: { tab: tab } } : {}
        );
    }

    startProgress() {
        this.isInProgress = true;
        this.utilService.startProgress();
    }

    endProgress() {
        this.isInProgress = false;
        this.utilService.endProgress();
    }


}



// WEBPACK FOOTER //
// ./src/app/shared/components/details/details.component.ts